import { resolveUploadsUrl } from '@/lib/uploads'

/** Как в классическом дашборде: не считаем ИИ в средних и «коллегах». */
export function isAIAssistantName(operatorName: string | null | undefined): boolean {
  if (!operatorName || typeof operatorName !== 'string') return false
  const s = operatorName.toLowerCase()
  return /аи\s*ассистент|ai\s*assistant|ассистент\s*аи|assistant\s*ai|мозгобот|mozgobot/.test(s)
}

export function isAIOperator(op: {
  operator_name?: string | null
  operator_email?: string | null
}): boolean {
  if (!op || typeof op !== 'object') return false
  const name = String(op.operator_name || '')
  const email = String(op.operator_email || '').toLowerCase()
  if (isAIAssistantName(name)) return true
  if (email.includes('ai-assistant@servicedesk.local')) return true
  return false
}

export const MOZGOBOT_STATIC_AVATAR = '/mozgobot-avatar.png'

export function resolveOperatorAvatarSrc(op: {
  operator_name?: string | null
  operator_email?: string | null
  avatar_url?: string | null
} | null | undefined): string | undefined {
  const raw = String(op?.avatar_url || '').trim()
  if (raw) return resolveUploadsUrl(raw)
  if (isAIOperator(op || {})) return MOZGOBOT_STATIC_AVATAR
  return undefined
}
